module.exports = __webpack_public_path__ + "media/images/Giphy logo-e5ad62f3.png";